jQuery(document).ready(function($) {
    const $slider = $('.js-racquet-testimonials-slider');

    if ($slider.length === 0) {
        return;
    }

    // Only one visible at a time, with dots and no peek of next slide
    $slider.flickity({
        cellAlign: 'left',
        contain: false,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        autoPlay: false,
        draggable: true,
        adaptiveHeight: true,
        groupCells: false
    });
});


